import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';

import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import '../css/requisition-app-styles.css';
import "../css/SurrenderForm.css";
import { useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import SurrenderFormPrintButton from './SurrenderFormPrintButton';
import ExportExcelButton from './ExportExcelButton';
import ExportPDFButton from './ExportPDFButton';
import { DateTime } from "luxon";
import Select from "react-select";
import PopupModal from "./PopupModal";
import { faCheckCircle, faTimesCircle, faWifi } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from "./LoadingOverlay";

// Add these helper functions
const getFieldLabel = (fieldName) => {
  const labelMap = {
    // General fields
    'NumberOfClientsAchieved': 'Number of Clients Achieved',
    'AchievedImpact': 'Achieved Impact',
    'From': 'Activity Start Date',
    'To': 'Activity End Date',
    'Country': 'Country',
    'BTOReport': 'BTO Report',
    'RequisitionID': 'Requisition ID',
    'UserID': 'User ID',
    'ActivityName': 'Activity Name',
    'ActivityPurpose': 'Activity Purpose',
    'StaffName': 'Staff Name',
    'StaffLevel': 'Staff Level',
    'SupervisorName': 'Supervisor Name',
    'HubOffice': 'Hub Office',
    'ProjectCode': 'Project Code',
    'ProjectName': 'Project Name',
    'BudgetLineCode': 'Budget Line Code',
    'TargetClient': 'Target Client',
    'ExpectedImpact': 'Expected Impact',
    'PayMode': 'Pay Mode',
    'Status': 'Status',
    'SurrenderDate': 'Surrender Date',
    'BankName': 'Bank Name',
    'branchName': 'Branch Name',
    'BankAccount': 'Bank Account',
    'PhoneNumber': 'Phone Number',
    
    // Cost driver fields
    'CostDriver': 'Cost Driver',
    'Quantity': 'Quantity',
    'UnitPrice': 'Unit Price',
    'ActualSpent': 'Actual Spent',
    'AttachmentType': 'Attachment Type',
    'Justification': 'Justification',
    'IsNew': 'Is New',
    
    // District/Area fields
    'District': 'District',
    'AreaProgram': 'Area Program/EPA',
    
    // Variance fields
    'ReasonForVariance': 'Reason for Variance',
    'Variance': 'Variance',
    'Advance': 'Advance',
  };
  
  // First, try exact match
  if (labelMap[fieldName]) {
    return labelMap[fieldName];
  }
  
  // Try to handle nested properties (e.g., CostDriverActuals[0].ActualSpent)
  const nestedCostDriverMatch = fieldName.match(/CostDriverActuals\[\d+\]\.(\w+)/);
  if (nestedCostDriverMatch && labelMap[nestedCostDriverMatch[1]]) {
    const index = parseInt(fieldName.match(/CostDriverActuals\[(\d+)\]/)[1]) + 1;
    return `${labelMap[nestedCostDriverMatch[1]]} (Cost Driver ${index})`;
  }
  
  // Handle AdvanceActualsAndVariances
  const nestedVarianceMatch = fieldName.match(/AdvanceActualsAndVariances\[\d+\]\.(\w+)/);
  if (nestedVarianceMatch && labelMap[nestedVarianceMatch[1]]) {
    const index = parseInt(fieldName.match(/AdvanceActualsAndVariances\[(\d+)\]/)[1]) + 1;
    return `${labelMap[nestedVarianceMatch[1]]} (Cost Driver ${index})`;
  }
  
  // Handle array indices for district pairs
  const districtMatch = fieldName.match(/DistrictAndAreaProgramPairsActuals\[\d+\]\.(\w+)/);
  if (districtMatch && labelMap[districtMatch[1]]) {
    const index = parseInt(fieldName.match(/DistrictAndAreaProgramPairsActuals\[(\d+)\]/)[1]) + 1;
    return `${labelMap[districtMatch[1]]} (Pair ${index})`;
  }
  
  // Fallback: convert camelCase to space-separated words
  return fieldName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .replace(/Id$/i, 'ID')
    .trim();
};

const formatValidationError = (message, fieldName = '') => {
  const friendlyField = fieldName ? getFieldLabel(fieldName) : '';
  
  // Pattern 1: "The value 'X' is not valid for FieldName."
  const pattern1 = /The value ['"]([^'"]+)['"] is not valid for (\w+)\./;
  const match1 = message.match(pattern1);
  if (match1) {
    const [, invalidValue, errorFieldName] = match1;
    const friendlyErrorField = getFieldLabel(errorFieldName);
    return `"${invalidValue}" is not a valid value for ${friendlyErrorField}.`;
  }
  
  // Pattern 2: "FieldName field is required."
  const pattern2 = /(\w+) field is required\./;
  const match2 = message.match(pattern2);
  if (match2) {
    const errorFieldName = match2[1];
    const friendlyErrorField = getFieldLabel(errorFieldName);
    return `${friendlyErrorField} is required.`;
  }
  
  // Pattern 3: "FieldName must be a number/string/etc."
  const pattern3 = /(\w+) must be a (\w+)\./;
  const match3 = message.match(pattern3);
  if (match3) {
    const [, errorFieldName, expectedType] = match3;
    const friendlyErrorField = getFieldLabel(errorFieldName);
    const typeMap = {
      'number': 'number',
      'string': 'text',
      'date': 'date',
      'boolean': 'yes/no value'
    };
    return `${friendlyErrorField} must be ${typeMap[expectedType] || expectedType}.`;
  }
  
  // Pattern 4: Simple field name in message
  if (friendlyField && message.includes(fieldName)) {
    return message.replace(fieldName, friendlyField);
  }
  
  // Default: return message as is
  return message;
};

const districts = [
  "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", "Kasungu",
  "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza", "Mzimba", "Neno",
  "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
];

const districtOptions = districts.map((district) => ({
  value: district,
  label: district
}));

const formatDate = (date) => date.toISOString().split('T')[0];
const surrenderDate = formatDate(new Date());

const currencyFormatter = new Intl.NumberFormat('en-MW', {
  style: 'currency',
  currency: 'MWK',
});

const formatCurrency = (value) => {
  // If value is null, undefined, or empty string, return empty string (nothing displayed)
  if (value === null || value === undefined || value === '') {
    return ''; 
  }
  const numValue = Number(value);
  // If it's NaN, return empty string
  if (isNaN(numValue)) {
    return '';
  }
  // If it's 0, return "0" (only when user actually entered 0)
  if (numValue === 0) {
    return '0';
  }
  return `MK ${numValue.toLocaleString('en-US')}`;
};

const toNumber = (v) => {
  if (v == null) return 0;
  const cleaned = String(v).replace(/mk/i, "").replace(/,/g, "").trim();
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
};

const formatCurrencyForSecondTable = (value) => {
  const num = toNumber(value);       
  if (num === 0) return "0";         
  return `MK ${num.toLocaleString("en-US")}`;
};



const SurrenderForm = () => {
  const navigate = useNavigate();
  const [costDriverOptions, setCostDriverOptions] = useState([]);
  const [blastingCostItems, setBlastingCostItems] = useState([]);
  const [blastingCostDriversActuals, setBlastingCostDriversActuals] = useState([]);
  const { requisitionID } = useParams();
  const [requisition, setRequisition] = useState(null);
  const [achievedClients, setAchievedClients] = useState("");
  const [achievedImpact, setAchievedImpact] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const theUserType = localStorage.getItem('userType');
  const theUserId = localStorage.getItem('userId');  
  const [isConfirmed, setisConfirmed] = useState(false);
  const [showSurrenderSubmittedModal, setShowSurrenderSubmittedModal] = useState(false);
  const signatureFilePath = localStorage.getItem("signatureFilePath");
  const fullName = localStorage.getItem('fullName') || "Name";
  const contentRef = useRef();
  const [formArray, setFormArray] = useState([]);
  const formData = new FormData();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [districtAndAreaProgramPairs, setDistrictAndAreaProgramPairs] = useState([]);
  const [costDriverActuals, setCostDriverActuals] = useState([]);
  const [advanceActualsAndVariances, setAdvanceActualsAndVariances] = useState([]);
  const [showNoInternetModal, setShowNoInternetModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    show: false,
    title: '',
    message: '',
  });
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showPopup, setShowPopup] = useState(false);
  const [duplicateFilePopup, setDuplicateFilePopup] = useState({
    show: false,
    duplicateFileName: "",
  });
  const [btoFile, setBtoFile] = useState(null);
  const btoInputRef = useRef(null);
  const [isPhysicalConfirmed, setIsPhysicalConfirmed] = useState(false);
  const [isDigitalConfirmed, setIsDigitalConfirmed] = useState(false);
  const [selectedAttachmentType, setSelectedAttachmentType] = useState(null);
  const [costDriversData, setCostDriversData] = useState([
    {
      costDriver: "",
      quantity: "",
      unitPrice: "",
      actualSpent: "",
      selectedFiles: [],
      isCustom: false,
      isNew: false, 
      attachmentType: "" 
    },
  ]);
  
  const [surrenderFormData, setSurrenderFormData] = useState({
    districtAndAreaProgramPairs: [],
    numberOfClientsAchieved: ''
  });

  useEffect(() => {
    function handleOnline()  { setIsOnline(true); }
    function handleOffline() { setIsOnline(false); }

    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

useEffect(() => {
  const fetchRequisitionDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisitionID}`
      );

      const data = response.data;
      setRequisition(data);

      const districtPairs = Array.isArray(data.districtAndAreaProgramPairs)
        ? data.districtAndAreaProgramPairs
        : [];

      setSurrenderFormData({
        districtAndAreaProgramPairs: districtPairs.map(pair => ({
          district: pair.district,
          areaProgram: pair.areaProgram,
        })),
        numberOfClientsAchieved: data.numberOfClientsAchieved || ''
      });

      const costDrivers = Array.isArray(data.costDrivers)
        ? data.costDrivers
        : [];

      setCostDriversData(
        costDrivers.map(driver => ({
          costDriver: driver.costDriver,
          quantity: "", 
          unitPrice: "",
          actualSpent: driver.actualSpent || "",
          selectedFiles: [],
          attachmentType: driver.attachmentType || "",
          justification: driver.justification || "",
          isCustom: false,
          isNew: false
        }))
      );

      // ✅ CORRECTED: Get blasting cost drivers once
      const blastingCostDrivers = Array.isArray(data.blastingCostDrivers)
          ? data.blastingCostDrivers
          : [];

      // Set blasting cost items (original data for advance values)
      setBlastingCostItems(
          blastingCostDrivers.map(driver => ({
              id: driver.id,
              costDriver: driver.costDriver || '',
              justification: driver.justification || '',
              quantity: driver.quantity || 0,
              unitPrice: driver.unitPrice || 0,
              total: driver.total || 0,
              supportDocuments: driver.supportDocuments || '',
              isCustom: false,
              customCostDriver: ''
          }))
      );

      // Set blasting cost drivers actuals (editable for surrender)
      setBlastingCostDriversActuals(
          blastingCostDrivers.map(driver => ({
              id: driver.id,
              costDriver: driver.costDriver || '',
              customCostDriver: '',
              isCustom: false,
              justification: driver.justification || '',
              quantity: "",  // Empty by default
              unitPrice: "",  // Empty by default
              actualSpent: "",
              selectedFiles: [],
              attachmentType: "",
              isNew: false
          }))
      );

      if (data.from && data.to) {
        const fromDate = new Date(data.from);
        const toDate = new Date(data.to);

        const localFromDate = new Date(
          fromDate.getTime() - fromDate.getTimezoneOffset() * 60000
        ).toISOString().split("T")[0];

        const localToDate = new Date(
          toDate.getTime() - toDate.getTimezoneOffset() * 60000
        ).toISOString().split("T")[0];

        setFrom(localFromDate);
        setTo(localToDate);
      }

      // Set achievedImpact if it exists in the data
      if (data.achievedImpact) {
        setAchievedImpact(data.achievedImpact);
      }

    } catch (error) {
      console.error("Error fetching requisition details:", error);
      
      let errorMessage = "Unable to load the requisition details. ";
      
      if (error.response) {
        switch (error.response.status) {
          case 404:
            errorMessage += "The requisition was not found.";
            break;
          case 401:
          case 403:
            errorMessage += "You don't have permission to view this requisition.";
            break;
          case 500:
            errorMessage += "Server error. Please try again later.";
            break;
          default:
            errorMessage += "Please try again or contact support.";
        }
      } else if (error.request) {
        errorMessage = "Unable to connect to the server. Please check your internet connection.";
      } else {
        errorMessage = "An unexpected error occurred. Please refresh the page.";
      }

      setErrorModal({
        show: true,
        title: 'Failed to Load',
        message: errorMessage,
      });
    }
  };

  fetchRequisitionDetails();
}, [requisitionID]);


useEffect(() => {
  const fetchCostDrivers = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`);
      const list = Array.isArray(data) ? data : data.$values || [];
      setCostDriverOptions(list);
    } catch (err) {
      console.error(err);
      setCostDriverOptions([]);
    }
  };
  fetchCostDrivers();
}, []);

const getDefaultUnitPrice = (driverName) => {
  const match = costDriverOptions.find(opt => opt.costDriver === driverName);
  const price = match?.defaultUnitPrice;
  return price > 0 ? price.toString() : "";
};

const getSupportDocuments = (driverName) => {
  const match = costDriverOptions.find(opt => opt.costDriver === driverName);
  return match?.supportDocuments || "Receipt(s)";
};

// Add this useEffect right after your fetchRequisitionDetails useEffect
useEffect(() => {
  // Only show loading issues after a delay
  const timer = setTimeout(() => {
    if (!requisition && !errorModal.show) {
      setErrorModal({
        show: true,
        title: 'Loading Issue',
        message: 'Taking too long to load. Please check your connection.',
      });
    }
  }, 10000); // Show after 10 seconds

  return () => clearTimeout(timer);
}, [requisition, errorModal.show]);

  useEffect(() => {
    if (!requisition) return;
  
    const driversArr = Array.isArray(requisition.costDrivers)
      ? requisition.costDrivers
      : []; 
  
    const newAavs = costDriversData.map((driver, i) => {
      const advance = Number(driversArr[i]?.total    || 0);
      const actual  = Number(driver.actualSpent       || 0);
      return {
        costDriver:  driver.costDriver,
        advance,
        actualSpent: actual,
        variance:    advance - actual,
      };
    });
  
    setAdvanceActualsAndVariances(newAavs);
  }, [costDriversData, requisition]);

  if (!requisition) {
    if (errorModal.show) {
      return (
        <div className="error-container">
          <h3>Unable to Load Surrender Form</h3>
          <p>There was a problem loading the Surrender Form.</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      );
    }
    return (
      <div className="fullscreen-spinner-container">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <p className="mt-3">Loading...</p>
      </div>
    );
  }

// Remove this line entirely - don't return early
// if (costDriversData.length === 0) return <p>No cost drivers available.</p>;

  

if (!Array.isArray(requisition.costDrivers)) {
  console.error("Expected requisition.costDrivers to be an array, got:", requisition.costDrivers);
  return <div>Loading cost drivers…</div>;
}


const validateSurrenderForm = () => {
  const errors = [];

  if (!achievedImpact) errors.push("Achieved Impact is required");
  if (!surrenderFormData.numberOfClientsAchieved) errors.push("Number of Clients Achieved is required");

  if (!from) errors.push("Activity Duration From date is required");
  if (!to) errors.push("Activity Duration To date is required");
  if (!requisition.country) errors.push("Country is required");

  if (!btoFile) errors.push("BTO is required");
  
  // Check district pairs
  if (surrenderFormData.districtAndAreaProgramPairs.length === 0) {
    errors.push("At least one District and Area Program pair is required");
  } else {
    surrenderFormData.districtAndAreaProgramPairs.forEach((pair, index) => {
      if (!pair.district) errors.push(`District and AP/EPA pair #${index + 1}: District is required`);
      if (!pair.areaProgram) errors.push(`District and AP/EPA pair #${index + 1}: Area Program is required`);
    });
  }

  // Check if any Other Cost Driver rows have actual data (not empty)
  const hasFilledOtherRow = costDriversData.some(driver => 
    driver.costDriver && 
    driver.costDriver.trim() !== '' &&
    driver.quantity !== '' && 
    driver.quantity !== null && 
    driver.quantity !== undefined &&
    driver.unitPrice !== '' && 
    driver.unitPrice !== null && 
    driver.unitPrice !== undefined &&
    driver.actualSpent !== '' && 
    driver.actualSpent !== null && 
    driver.actualSpent !== undefined
  );

  // Check if any Blasting rows have actual data (not empty)
  const hasFilledBlastingRow = blastingCostDriversActuals.some(driver => 
    driver.costDriver && 
    driver.costDriver.trim() !== '' &&
    driver.quantity !== '' && 
    driver.quantity !== null && 
    driver.quantity !== undefined &&
    driver.unitPrice !== '' && 
    driver.unitPrice !== null && 
    driver.unitPrice !== undefined &&
    driver.actualSpent !== '' && 
    driver.actualSpent !== null && 
    driver.actualSpent !== undefined
  );

  // Only validate Other Cost Drivers if they have filled rows
  if (hasFilledOtherRow) {
    costDriversData.forEach((driver, index) => {
      if (!driver.costDriver) errors.push(`Cost Driver #${index + 1}: Name is required`);
      
      // VALIDATION FOR QUANTITY AND UNIT PRICE - Allow 0 as valid
      if (driver.quantity === '' || driver.quantity === null || driver.quantity === undefined) {
        errors.push(`Cost Driver #${index + 1}: quantity is required`);
      }
      if (driver.unitPrice === '' || driver.unitPrice === null || driver.unitPrice === undefined) {
        errors.push(`Cost Driver #${index + 1}: unit price is required`);
      }
      
      if (driver.actualSpent === '' || driver.actualSpent === null || driver.actualSpent === undefined) {
        errors.push(`Cost Driver #${index + 1}: actual spent amount is required`);
      }
      
      // ENHANCED ATTACHMENT VALIDATION - Skip if actualSpent is 0
      const actualSpentValue = Number(driver.actualSpent);
      if (actualSpentValue !== 0 || driver.actualSpent === '' || driver.actualSpent === null || driver.actualSpent === undefined) {
        if (!driver.attachmentType) {
          errors.push(`Cost Driver #${index + 1}: Please select either Physical or Digital attachments`);
        } else if (driver.attachmentType === 'digital' && (!driver.selectedFiles || driver.selectedFiles.length === 0)) {
          errors.push(`Cost Driver #${index + 1}: Digital attachments require at least one PDF file`);
        }
      }

      // Check for variance reasons when there's a variance
      const advance = Number(requisition.costDrivers[index]?.total || 0);
      const actual = Number(driver.actualSpent || 0);
      const variance = Math.abs(advance - actual);
      if (variance > 0.01 && !driver.reasonForVariance) {
        errors.push(`Cost Driver #${index + 1}: Reason for variance is required when there is a difference between advance and actual spent`);
      }
    });
  }

  // Only validate Blasting Cost Drivers if they have filled rows
  if (hasFilledBlastingRow) {
    blastingCostDriversActuals.forEach((driver, index) => {
      if (!driver.costDriver) errors.push(`Blasting Cost Driver #${index + 1}: Name is required`);
      
      if (driver.quantity === '' || driver.quantity === null || driver.quantity === undefined) {
        errors.push(`Blasting Cost Driver #${index + 1}: quantity is required`);
      }
      if (driver.unitPrice === '' || driver.unitPrice === null || driver.unitPrice === undefined) {
        errors.push(`Blasting Cost Driver #${index + 1}: unit price is required`);
      }
      
      if (driver.actualSpent === '' || driver.actualSpent === null || driver.actualSpent === undefined) {
        errors.push(`Blasting Cost Driver #${index + 1}: actual spent amount is required`);
      }
      
      // ENHANCED ATTACHMENT VALIDATION - Skip if actualSpent is 0
      const actualSpentValue = Number(driver.actualSpent);
      if (actualSpentValue !== 0 || driver.actualSpent === '' || driver.actualSpent === null || driver.actualSpent === undefined) {
        if (!driver.attachmentType) {
          errors.push(`Blasting Cost Driver #${index + 1}: Please select either Physical or Digital attachments`);
        } else if (driver.attachmentType === 'digital' && (!driver.selectedFiles || driver.selectedFiles.length === 0)) {
          errors.push(`Blasting Cost Driver #${index + 1}: Digital attachments require at least one PDF file`);
        }
      }

      // Check for variance reasons when there's a variance
      const advance = Number(blastingCostItems[index]?.total || 0);
      const actual = Number(driver.actualSpent || 0);
      const variance = Math.abs(advance - actual);
      if (variance > 0.01 && !driver.reasonForVariance) {
        errors.push(`Blasting Cost Driver #${index + 1}: Reason for variance is required when there is a difference between advance and actual spent`);
      }
    });
  }

  // Add a friendly message if neither table has data (but keep as a warning, not an error)
  if (!hasFilledOtherRow && !hasFilledBlastingRow) {
    // This is just a warning, not an error - user can still submit
    // You might want to show a warning in the UI instead of blocking submission
    // For now, we'll add it as a warning (not an error) so it doesn't block submission
    // errors.push("At least one cost driver table must have filled rows");
  }

  return errors;
};

const handleBlastingActualInputChange = (index, field, value) => {
    const updatedDrivers = [...blastingCostDriversActuals];
    updatedDrivers[index][field] = value;
    
    // Only calculate actual spent when BOTH quantity AND unitPrice have values
    if (field === "quantity" || field === "unitPrice") {
        const quantity = updatedDrivers[index].quantity;
        const unitPrice = updatedDrivers[index].unitPrice;
        
        // Only calculate if BOTH fields have values (not empty and not null)
        if (quantity !== '' && quantity !== null && quantity !== undefined && 
            unitPrice !== '' && unitPrice !== null && unitPrice !== undefined) {
            const qty = Number(quantity) || 0;
            const price = Number(unitPrice) || 0;
            updatedDrivers[index].actualSpent = qty * price;
        } else {
            // If either field is empty, clear actualSpent
            updatedDrivers[index].actualSpent = '';
        }
    } else if (field === "actualSpent") {
        // When actual spent changes, calculate quantity
        const actualSpent = Number(value) || 0;
        const unitPrice = Number(updatedDrivers[index].unitPrice) || 0;
        if (unitPrice !== 0 && updatedDrivers[index].unitPrice !== '' && updatedDrivers[index].unitPrice !== null) {
            updatedDrivers[index].quantity = actualSpent / unitPrice;
        } else {
            // If unitPrice is empty or 0, set quantity to empty
            updatedDrivers[index].quantity = '';
        }
    }
    
    setBlastingCostDriversActuals(updatedDrivers);
};

const handleBlastingAttachmentTypeChange = (index, type) => {
    const updatedDrivers = [...blastingCostDriversActuals];
    updatedDrivers[index].attachmentType = type;
    if (type === 'physical') {
        updatedDrivers[index].selectedFiles = [];
    }
    setBlastingCostDriversActuals(updatedDrivers);
};

const handleBlastingFileChange = (index, event) => {
    const fileInput = event.target;
    const newFiles = Array.from(fileInput.files);
    
    const validFiles = newFiles.filter(file => file.type === "application/pdf");
    
    if (validFiles.length === 0) {
        fileInput.value = "";
        return;
    }

    const updatedDrivers = [...blastingCostDriversActuals];
    const currentFiles = updatedDrivers[index].selectedFiles || [];

    const uniqueFiles = validFiles.filter(file => !isDuplicateFile(file, currentFiles));

    if (uniqueFiles.length === 0) {
        fileInput.value = "";
        return;
    }

    updatedDrivers[index].selectedFiles = [...currentFiles, ...uniqueFiles];
    setBlastingCostDriversActuals(updatedDrivers);
    fileInput.value = "";
};

const handleReasonForVarianceChange = (index, value) => {
  setCostDriversData(prev => {
    const updated = [...prev];
    updated[index] = {
      ...updated[index],
      reasonForVariance: value
    };
    return updated;
  });
};

  const handleSupportDocumentsCheckboxChange = (attachmentType, index) => {
    const updatedCostDrivers = [...costDriversData];
    updatedCostDrivers[index].attachmentType = attachmentType;
    if (attachmentType === "physical") {
      updatedCostDrivers[index].selectedFiles = [];
    }
    setCostDriversData(updatedCostDrivers);
  };
  
  const handleJustificationChange = (index, value) => {
    setCostDriversData((prevData) =>
      prevData.map((cDriver, i) =>
        i === index ? { ...cDriver, justification: value } : cDriver
      )
    );
  };

  const handleSurrenderSubmittedModalClose = () => {
    setShowSurrenderSubmittedModal(false);
    navigate('/requisitions');
  };
  
  const handleDistrictChange = (index, selectedOption) => {
    setSurrenderFormData((prevState) => {
        const updatedPairs = [...prevState.districtAndAreaProgramPairs];
        if (!updatedPairs[index]) {
            updatedPairs[index] = { district: "", areaProgram: "" }; 
        }
        updatedPairs[index].district = selectedOption ? selectedOption.value : ""; 
        return { ...prevState, districtAndAreaProgramPairs: updatedPairs };
    });
  };

  const handleAreaProgramChange = (index, newValue) => {
    setSurrenderFormData(prevData => {
        const updatedPairs = [...prevData.districtAndAreaProgramPairs];
        if (!updatedPairs[index]) {
            updatedPairs[index] = {}; 
        }
        updatedPairs[index].areaProgram = newValue || ""; 
        return { ...prevData, districtAndAreaProgramPairs: updatedPairs };
    });
  };

  const handleCostDriverChange = (index, value) => {
    setCostDriversData((prevDrivers) => {
      const updatedDrivers = [...prevDrivers];
      updatedDrivers[index].costDriver = value === "Other" ? "" : value; 
      updatedDrivers[index].isCustom = value === "Other"; 
      return updatedDrivers;
    });
  };

  const handleCustomInputChange = (index, value) => {
    setCostDriversData((prevDrivers) => {
      const updatedDrivers = [...prevDrivers];
      updatedDrivers[index].costDriver = value;
      return updatedDrivers;
    });
  };

  const addRow = () => {
    setCostDriversData((prevDrivers) => [
      ...prevDrivers,
      {
        costDriver: "",
        quantity: "",
        unitPrice: "",
        actualSpent: "",
        selectedFiles: [],
        isCustom: false,
        isNew: true,
      },
    ]);
  };

  const removeRow = (index) => {
    setCostDriversData((prevDrivers) => prevDrivers.filter((_, i) => i !== index));
  };
  



  const totalVariance = costDriversData.reduce((sum, driver, i) => {
    const advance    = Number(requisition.costDrivers[i]?.total   || 0);
    const actual     = Number(driver.actualSpent                  || 0);
    return sum + (advance - actual);
  }, 0);

  // Calculate blasting total variance
  const blastingTotalVariance = blastingCostDriversActuals.reduce((sum, driver, index) => {
      const advance = Number(blastingCostItems[index]?.total || 0);
      const actualSpent = Number(driver.actualSpent || 0);
      return sum + (advance - actualSpent);
  }, 0);

  // Calculate other cost drivers total variance
  const otherTotalVariance = costDriversData.reduce((sum, driver, i) => {
      const advance = Number(requisition.costDrivers[i]?.total || 0);
      const actual = Number(driver.actualSpent || 0);
      return sum + (advance - actual);
  }, 0);

  // Calculate overall total
  const overallTotalVariance = blastingTotalVariance + otherTotalVariance;


  const handleInputChange = (index, field, value) => {
      const updatedCostDrivers = [...costDriversData];
      updatedCostDrivers[index][field] = value;

      if (value === "Other") {
          updatedCostDrivers[index].isCustom = true;
          updatedCostDrivers[index].costDriver = ""; 
      } else {
          updatedCostDrivers[index].isCustom = false;
      }
    
      // Only calculate actual spent when BOTH quantity AND unitPrice have values
      if (field === "quantity" || field === "unitPrice") {
          const quantity = updatedCostDrivers[index].quantity;
          const unitPrice = updatedCostDrivers[index].unitPrice;
          
          // Only calculate if BOTH fields have values (not empty and not null)
          if (quantity !== '' && quantity !== null && quantity !== undefined && 
              unitPrice !== '' && unitPrice !== null && unitPrice !== undefined) {
              const qty = Number(quantity) || 0;
              const price = Number(unitPrice) || 0;
              updatedCostDrivers[index].actualSpent = qty * price;
          } else {
              // If either field is empty, clear actualSpent
              updatedCostDrivers[index].actualSpent = '';
          }
      } else if (field === "actualSpent") {
          // When actual spent changes, calculate quantity
          const actualSpent = Number(value) || 0;
          const unitPrice = Number(updatedCostDrivers[index].unitPrice) || 0;
          if (unitPrice !== 0 && updatedCostDrivers[index].unitPrice !== '' && updatedCostDrivers[index].unitPrice !== null) {
              updatedCostDrivers[index].quantity = actualSpent / unitPrice;
          } else {
              // If unitPrice is empty or 0, set quantity to empty
              updatedCostDrivers[index].quantity = '';
          }
      }

      setCostDriversData(updatedCostDrivers);
      console.log('Updated CostDriversData:', updatedCostDrivers);
  };


  const addDistrictAPPair = () => {
    setSurrenderFormData(prevData => ({
      ...prevData,
      districtAndAreaProgramPairs: [
        ...prevData.districtAndAreaProgramPairs,
        { district: "", areaProgram: "" }
      ]
    }));
  };

  const removeDistrictAPPair = (index) => {
    setSurrenderFormData(prevData => ({
      ...prevData,
      districtAndAreaProgramPairs: prevData.districtAndAreaProgramPairs.filter((_, i) => i !== index)
    }));
  };

  const closeDuplicateFilePopup = () => {
    setDuplicateFilePopup({ show: false, duplicateFileName: "" });
  };

  const handleFileChange = (index, event) => {
    const fileInput = event.target; 
    const newFiles = Array.from(fileInput.files);
    
    const validFiles = newFiles.filter(file => file.type === "application/pdf");
    
    if (validFiles.length === 0) {
      fileInput.value = ""; 
      return;
    }

    const updatedCostDrivers = [...costDriversData];
    const currentFiles = updatedCostDrivers[index].selectedFiles || [];

    const uniqueFiles = validFiles.filter(file => !isDuplicateFile(file, currentFiles));

    if (uniqueFiles.length === 0) {
      console.log("All files are duplicates and won't be added again.");
      fileInput.value = "";
      return;
    }

    updatedCostDrivers[index].selectedFiles = [...currentFiles, ...uniqueFiles];
    setCostDriversData(updatedCostDrivers);
    fileInput.value = "";
  };




  const isDuplicateFile = (newFile, existingFiles) => {
    return existingFiles.some(existingFile => 
      existingFile.name === newFile.name &&
      existingFile.size === newFile.size &&
      existingFile.lastModified === newFile.lastModified
    );
  };

  const closePopup = () => {
    setShowPopup(false);
  };  
    
  const handleSubmit = async (event) => {
    event.preventDefault();

    setSubmitAttempted(true);

    // Run validation
  const validationErrors = validateSurrenderForm();
  if (validationErrors.length > 0) {
    alert("Please fix the following errors:\n" + validationErrors.join("\n"));
    return;
  }


    if (!navigator.onLine) {
      setShowNoInternetModal(true);
      return;
    }

    setIsSubmitting(true);
    try 
    {
      const formData = new FormData();

      formData.append('RequisitionID', requisition.requisitionID);
      formData.append('UserID', theUserId);
      formData.append('ActivityName', requisition.activityName);
      formData.append('ActivityPurpose', requisition.activityPurpose);
      formData.append('StaffName', requisition.staffName);
      formData.append('StaffLevel', requisition.staffLevel);
      formData.append('SupervisorName', requisition.supervisorName);
      formData.append('Country', requisition.country);
      formData.append('HubOffice', requisition.hubOffice);
      formData.append('ProjectCode', requisition.projectCode);
      formData.append('ProjectName', requisition.projectName);
      formData.append('BudgetLineCode', requisition.budgetLineCode);
      formData.append('TargetClient', requisition.targetClient);
      formData.append('ExpectedImpact', requisition.expectedImpact);
      formData.append('AchievedImpact', achievedImpact);
      formData.append('PayMode', requisition.payMode);
      formData.append('Status', 'Surrender Submitted');
      formData.append('SurrenderDate', surrenderDate);
      formData.append('From', requisition.from);
      formData.append('To', requisition.to);

      formData.append(
        'NumberOfClientsAchieved',
        (surrenderFormData.numberOfClientsAchieved || '0').toString()
      );
      
      formData.append('BankName',    requisition.bankName    || '');
      formData.append('branchName',  requisition.branch  || '');
      formData.append('BankAccount', requisition.accountNumber || '');
      formData.append('PhoneNumber', requisition.phoneNumber || '');

      console.log('District and Area Program Pairs before submission:', surrenderFormData.districtAndAreaProgramPairs);

      surrenderFormData.districtAndAreaProgramPairs.forEach((pair, index) => {
        console.log(`Adding pair ${index}:`, pair);
        formData.append(`DistrictAndAreaProgramPairsActuals[${index}].District`, pair.district);
        formData.append(`DistrictAndAreaProgramPairsActuals[${index}].AreaProgram`, pair.areaProgram);
        formData.append(`DistrictAndAreaProgramPairsActuals[${index}].RequisitionID`, requisitionID);
      });

      costDriversData.forEach((driver, index) => {
        formData.append(`CostDriverActuals[${index}].CostDriver`, driver.costDriver);
        formData.append(`CostDriverActuals[${index}].Justification`, driver.justification || '');
        formData.append(`CostDriverActuals[${index}].Quantity`, driver.quantity.toString());
        formData.append(`CostDriverActuals[${index}].UnitPrice`, driver.unitPrice.toString());
        formData.append(`CostDriverActuals[${index}].ActualSpent`, driver.actualSpent.toString());
        // If actualSpent is 0, set attachment type to "N/A (no attachment)"
        const actualSpentValue = Number(driver.actualSpent);
        const attachmentTypeValue = (actualSpentValue === 0 && driver.actualSpent !== '' && driver.actualSpent !== null && driver.actualSpent !== undefined) 
          ? 'N/A (no attachment)' 
          : (driver.attachmentType || 'physical');
        formData.append(`CostDriverActuals[${index}].AttachmentType`, attachmentTypeValue);
        formData.append(`CostDriverActuals[${index}].RequisitionID`, requisition.requisitionID);
        formData.append(
          `CostDriverActuals[${index}].IsNew`,
          driver.isNew ? "true" : "false"
        );

        if (driver.attachmentType === 'digital' && driver.selectedFiles) {
          driver.selectedFiles.forEach(file => {
            formData.append(`files[${index}]`, file);
          });

          
        }

        const actualSpent = parseFloat(driver.actualSpent) || 0;
        const advance = Number(requisition.costDrivers[index]?.total || 0);
        const variance = advance - actualSpent;

        formData.append(`AdvanceActualsAndVariances[${index}].CostDriver`, driver.costDriver);
        formData.append(`AdvanceActualsAndVariances[${index}].Advance`, advance.toString());
        formData.append(`AdvanceActualsAndVariances[${index}].ActualSpent`, actualSpent.toString());
        formData.append(`AdvanceActualsAndVariances[${index}].Variance`, variance.toString());
        formData.append(`AdvanceActualsAndVariances[${index}].ReasonForVariance`, driver.reasonForVariance || ''); 
        formData.append(`AdvanceActualsAndVariances[${index}].RequisitionID`, requisition.requisitionID);
      });

      // ===== PROCESS BLASTING COST DRIVERS =====
      if (blastingCostDriversActuals && blastingCostDriversActuals.length > 0) {
        blastingCostDriversActuals.forEach((driver, index) => {
          // Only include rows that have data
          if (driver.costDriver || driver.quantity || driver.unitPrice || driver.actualSpent) {
            formData.append(`BlastingCostDriverActuals[${index}].CostDriver`, driver.costDriver || '');
            formData.append(`BlastingCostDriverActuals[${index}].Justification`, driver.justification || '');
            formData.append(`BlastingCostDriverActuals[${index}].Quantity`, driver.quantity || '0');
            formData.append(`BlastingCostDriverActuals[${index}].UnitPrice`, driver.unitPrice || '0');
            formData.append(`BlastingCostDriverActuals[${index}].ActualSpent`, driver.actualSpent || '0');

            const actualSpentValue = Number(driver.actualSpent);
            const attachmentTypeValue = (actualSpentValue === 0 && driver.actualSpent !== '' && driver.actualSpent !== null && driver.actualSpent !== undefined) 
              ? 'N/A (no attachment)' 
              : (driver.attachmentType || 'physical');
            formData.append(`BlastingCostDriverActuals[${index}].AttachmentType`, attachmentTypeValue);
            formData.append(`BlastingCostDriverActuals[${index}].RequisitionID`, requisition.requisitionID);
            formData.append(`BlastingCostDriverActuals[${index}].IsNew`, driver.isNew ? "true" : "false");

            // Handle blasting files
            if (driver.attachmentType === 'digital' && driver.selectedFiles) {
              driver.selectedFiles.forEach(file => {
                formData.append(`blastingFiles[${index}]`, file);
              });
            }

            // Calculate blasting advance, actuals & variances
            const advance = Number(blastingCostItems[index]?.total || 0);
            const actualSpent = Number(driver.actualSpent) || 0;
            const variance = advance - actualSpent;

            formData.append(`BlastingAdvanceActualsAndVariances[${index}].CostDriver`, driver.costDriver || '');
            formData.append(`BlastingAdvanceActualsAndVariances[${index}].Advance`, advance.toString());
            formData.append(`BlastingAdvanceActualsAndVariances[${index}].ActualSpent`, actualSpent.toString());
            formData.append(`BlastingAdvanceActualsAndVariances[${index}].Variance`, variance.toString());
            formData.append(`BlastingAdvanceActualsAndVariances[${index}].ReasonForVariance`, driver.reasonForVariance || '');
            formData.append(`BlastingAdvanceActualsAndVariances[${index}].RequisitionID`, requisition.requisitionID);
          }
        });
      }

      if (btoFile) {
        formData.append('BTOReport', btoFile);
      }
      
      console.log('Form Data Contents:');
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/surrender`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
         timeout: 120000, // 2 minutes //timeout: 1, //timeout: 30000, 
        }
      );

      if (response.status === 200 || response.status === 201) {
        setShowSurrenderSubmittedModal(true);
      }
    } catch (error) {
  console.error("Error submitting surrender:", error);
  
  if (error.response) {
    console.error("Response data:", error.response.data);
    console.error("Response status:", error.response.status);
    console.error("Response headers:", error.response.headers);
  }

  let userMessage = "Something went wrong while submitting the surrender. Please try again.";

      if (error.response) {
        // Server responded
        switch (error.response.status) {
          
           case 400:
            // Check if it's a validation error from the server
            if (error.response.data?.errors) {
              // Server returned specific field errors
              const errorMessages = [];
              
              Object.entries(error.response.data.errors).forEach(([field, messages]) => {
                const friendlyField = getFieldLabel(field);
                const fieldMessages = Array.isArray(messages) ? messages : [messages];
                
                fieldMessages.forEach(message => {
                  const formattedMessage = formatValidationError(message, field);
                  errorMessages.push(`- ${friendlyField}: ${formattedMessage}`);
                });
              });
              
              userMessage = `Errors:\n${errorMessages.join('\n')}`;
            } else if (error.response.data?.message) {
              // Process the message to replace field names
              const message = error.response.data.message;
              
              // Check for patterns like "The value '90 Buyers' is not valid for NumberOfClientsAchieved."
              const pattern1 = /The value ['"]([^'"]+)['"] is not valid for (\w+)\./;
              const match1 = message.match(pattern1);
              if (match1) {
                const [, invalidValue, fieldName] = match1;
                const friendlyField = getFieldLabel(fieldName);
                userMessage = `Errors:\n• ${friendlyField}: "${invalidValue}" is not a valid number.`;
              } 
              // Check for other common validation patterns
              else if (message.includes('validation') || message.includes('Validation')) {
                userMessage = message;
              } else if (message.includes('Required') || message.includes('required') || message.includes('missing')) {
                userMessage = message;
              } else if (message.includes('invalid') || message.includes('Invalid')) {
                userMessage = message;
              } else {
                userMessage = message;
              }
            } else {
              // Generic 400 error
              userMessage = "Some required information is missing or invalid. Please check all fields and try again.";
            }
            break;

          case 401:
          userMessage = "Your session has expired. Please log in again.";
          break;

          case 403:
            userMessage = "You are not authorized to submit this surrender.";
            break;

          case 409:
          userMessage = "This requisition may already have a surrender submitted.";
          break;  

          case 413:
            userMessage = "One of the files you upload is too large. Please reduce the file size(s) and try again.";
            break;

          case 422:
          userMessage = "Validation failed. Please check all required fields and attachments.";
          break;
          // I should remember to test the code below
          case 500:
          case 502:
          case 503:
          case 504:
            userMessage = "The server is temporarily unavailable. Please try again in a few minutes.";
            break;

          default:
          userMessage = `Submission failed (Error ${error.response.status}). Please try again or contact the Digital Team.`;
            }
      } 
      else if (error.request) {
        // Request made but no response
        userMessage = "Sorry, it looks like your internet quality is poor at the moment. Please try again or try to switch to a different internet service provider";
      }
      else if (error.code === 'ECONNABORTED') {
        userMessage = "A process is taking too long. Please check your internet connection and try again. or Try to switch to a service provider with a stronger internet connection";
      } 
      else {
        // Axios setup error
        userMessage = "An unexpected error occurred. Please refresh the page and try again.";
      }

      setErrorModal({
        show: true,
        title: "Error: Submission Failed",
        message: userMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAttachmentTypeChange = (index, type) => {
    const updatedCostDrivers = [...costDriversData];
    updatedCostDrivers[index].attachmentType = type;
    
    if (type === 'physical') {
      updatedCostDrivers[index].selectedFiles = [];
    }
    
    setCostDriversData(updatedCostDrivers);
  };

  if (!requisition)
    return <div className="spinner-border" role="status"></div>;
  
  const handleCheckboxChange = () => {
    setisConfirmed((prev) => !prev);
  };

  return (
    <div id="wrapper">

      <LoadingOverlay isVisible={isSubmitting} />

      <Sidebar userType={theUserType} />

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
              <i className="fa fa-bars"></i>
            </button>
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                  aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>

          <div className="container-fluid">
            <div className="view-requisition-header">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="nav-link btn p-0"
                style={{ background: 'none', border: 'none' }}
              >
                <i className="fas fa-arrow-left back-button"></i>
              </button>
              <h1 className="h3">Surrender Form</h1>
            </div>
          
            <div className="buttons-container">
              <SurrenderFormPrintButton targetId="printable-area" />
              <ExportExcelButton
                formArray={formArray}
                setFormArray={setFormArray}
                currentFormData={formData}
                fileName="Surrender Form.xlsx"
              />
              <ExportPDFButton contentRef={contentRef} />
            </div>

            <div id="printable-area" ref={contentRef} style={{ padding: '20px' }}>
              <form onSubmit={handleSubmit}>
                <div className="requisition-details" >
                  <div className="view-requisition-date-and-id" id="status" hidden>
                    <div>
                      <label><strong>Surrender Date: </strong></label>
                      <input type="date" value={surrenderDate} readOnly />
                    </div>
                    <p><strong>Requisition ID:</strong> {requisition.requisitionID}</p>
                  </div>
                
                  <div className="staff-activity-container">
                    <div className="form-group">
                      <h3>Staff Details</h3>
                      <div className="form-field">
                        <label>Staff Name:</label>
                        <input type="text" value={requisition.staffName} readOnly className="read-only" />
                      </div>
                    </div>

                    <div className="form-group">
                      <h3>Activity Details</h3>
                      <div className="form-field">
                      <div className="field-container">
                        <label>Activity Duration<span className="required-asterisk">*</span></label>
                        <div className="date-input-container">
                          <label>From:<span className="required-asterisk">*</span></label>
                          <div className="date-input-wrapper">
                            <input
                              type="date"
                              name="from"
                              value={from}
                              onChange={(e) => setFrom(e.target.value)}
                              className={submitAttempted && !from ? 'required-field' : (from ? 'has-value' : '')}
                            />
                            <i className="fas fa-calendar-alt"></i>
                          </div>
                        </div>
                        <div className="date-input-container">
                          <label>To:<span className="required-asterisk">*</span></label>
                          <div className="date-input-wrapper">
                            <input
                              type="date"
                              name="to"
                              value={to}
                              onChange={(e) => setTo(e.target.value)}
                              className={submitAttempted && !to ? 'required-field' : (to ? 'has-value' : '')}
                            />
                            <i className="fas fa-calendar-alt"></i>
                          </div>
                        </div>
                      </div>
                    </div>                     
                      <br />

                      <div className="form-field">
                        <label>Activity Name:</label>
                        <input type="text" value={requisition.activityName} readOnly className="read-only"/>
                      </div>
                      <div className="form-field">
                        <label>Activity Purpose:</label>
                        <input type="text" value={requisition.activityPurpose} readOnly className="read-only"/>
                      </div>
                      <div className="form-field">
                        <label>Target Client:</label>
                        <input type="text" value={requisition.targetClient} readOnly className="read-only"/>
                      </div>
                     <div className="form-field">
                        <label>Number of Clients Achieved:<span className="required-asterisk">*</span></label>
                        <input
                          name="numberOfClientsAchieved"
                          value={surrenderFormData.numberOfClientsAchieved}
                          onChange={e =>
                            setSurrenderFormData(fd => ({
                              ...fd,
                              numberOfClientsAchieved: e.target.value
                            }))
                          }
                          className={`form-control ${submitAttempted && !surrenderFormData.numberOfClientsAchieved ? 'required-field' : ''}`}
                        />
                      </div>

                      <div className="form-field">
                        <label>Expected Impact:</label>
                        <input type="text" value={requisition.expectedImpact} readOnly className="read-only"/>
                      </div>
                      <div className="form-field">
                        <label>Achieved Impact:<span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="achievedImpact"
                          value={achievedImpact}
                          onChange={(e) => setAchievedImpact(e.target.value)}
                          className={submitAttempted && !achievedImpact ? 'required-field' : ''}
                        />
                      </div>
                      <div className="form-field">
                        <div className={`bto-upload-container ${submitAttempted && !btoFile ? 'bto-validation-error' : ''}`}>
                          <button
                            type="button"
                            className={`btn ${submitAttempted && !btoFile ? 'btn-danger' : 'btn-secondary'}`}
                            onClick={() => btoInputRef.current?.click()}
                          >
                            Upload BTO Report
                          </button>
                          <input
                            type="file"
                            accept=".pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            ref={btoInputRef}
                            style={{ display: 'none' }}
                            onChange={e => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              const allowed = [
                                'application/pdf',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                              ];  
                              if (allowed.includes(file.type)) {
                                setBtoFile(file);
                              } else {
                                e.target.value = '';
                              }
                            }}
                          />
                          {btoFile && (
                            <div className="bto-filename">
                              {btoFile.name}
                            </div>
                          )}
                          {submitAttempted && !btoFile && (
                            <div className="validation-message" style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                              Please attach your BTO
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-field">
                        <label>Country:<span className="required-asterisk">*</span></label>
                        <input 
                          type="text" 
                          value={requisition.country} 
                          readOnly 
                          className={`read-only ${submitAttempted && !requisition.country ? 'required-field' : ''}`}
                        />
                      </div>
                     {surrenderFormData.districtAndAreaProgramPairs.length > 0 ? (
                        surrenderFormData.districtAndAreaProgramPairs.map((pair, index) => (
                          <div key={index} className="field-container">
                            <div className="form-field">
                              <label>District:<span className="required-asterisk">*</span></label>
                              <div className={submitAttempted && !pair.district ? 'react-select-required' : ''}>
                                <Select
                                  options={districtOptions}
                                  value={districtOptions.find(option => option.value === pair.district)}
                                  onChange={selectedOption => handleDistrictChange(index, selectedOption)}
                                  placeholder="Select District"
                                  isClearable
                                  className="custom-select-control"
                                />
                              </div>

                              <label>Area Program:<span className="required-asterisk">*</span></label>
                              <input
                                type="text"
                                value={pair.areaProgram}
                                onChange={event => handleAreaProgramChange(index, event.target.value)}
                                className={submitAttempted && !pair.areaProgram ? 'required-field' : ''}
                              />

                              <br /><br />
                            </div>
                            {index === 0 && (
                              <button
                                type="button"
                                className="add-button"
                                onClick={addDistrictAPPair}
                              >
                                +
                              </button>
                            )}

                            {index > 0 && (
                              <button
                                type="button"
                                className="remove-button"
                                onClick={() => removeDistrictAPPair(index)}
                              >
                                X
                              </button>
                            )}
                          </div>
                        ))
                      ) : (
                        <p>No district and area program pairs available.</p>
                      )}
                      <div className="form-field">
                        <label>Hub Office:</label>
                        <input type="text" value={requisition.hubOffice} readOnly className="read-only"/>
                      </div>
                      <div className="form-field">
                        <label>Status:</label>
                        <input type="text" value={requisition.status} readOnly className="read-only" />
                      </div>
                    </div>

                    <div className="form-group">
                      <h3>Project & Advance Details</h3>
                      
                      <div className="form-field">
                        <label>Project Code:</label>
                        <input type="text" value={requisition.projectCode} readOnly className="read-only"/>
                      </div>
                      <div className="form-field">
                        <label>Project Name:</label>
                        <input type="text" value={requisition.projectName} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Budget Line Code:</label>
                        <input type="text" value={requisition.budgetLineCode} readOnly className="read-only"/>
                      </div>
                      
                      <div className="form-field">
                        <label>Pay Mode:</label>
                        <input type="text" value={requisition.payMode} readOnly className="read-only" />
                      </div>
                      <div className="form-field">
                        <label>Bank Name:</label>
                        <input
                          type="text"
                          value={requisition.bankName || ''}
                          readOnly
                          className="form-control read-only"
                        />
                      </div>

                      <div className="form-field">
                        <label>Branch Name:</label>
                        <input
                          type="text"
                          value={requisition.branch || ''}
                          readOnly
                          className="form-control read-only"
                        />
                      </div>

                      <div className="form-field">
                        <label>Account:</label>
                        <input
                          type="text"
                          value={requisition.accountNumber || ''}
                          readOnly
                          className="form-control read-only"
                        />
                      </div>

                      <div className="form-field">
                        <label>Phone Number:</label>
                        <input
                          type="text"
                          value={requisition.phoneNumber || ''}
                          readOnly
                          className="form-control read-only"
                        />
                      </div>
                    </div>
                  </div>

            {/* Blasting Cost Drivers – Actuals Table */}
            {/* Blasting Cost Drivers – Actuals Table */}
            <div id="cost-drivers-wrapper">
                <div id="blasting-div">
                    <h3 id="blasting-heading">Blasting Cost Drivers – Actuals</h3>
                </div>

                {blastingCostDriversActuals && blastingCostDriversActuals.length > 0 ? (
                    <table className="table-bordered">
                        <thead>
                            <tr>
                                <th>Cost Driver</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>Actual Spent</th>
                                <th>Support Documents (PDF)</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {blastingCostDriversActuals.map((driver, index) => {
                                const rowClass = driver.isNew ? "new-row" : "";  // ✅ ADD THIS LINE
                                
                                return (
                                    <tr key={driver.id || index} className={rowClass}>  {/* ✅ ADD className={rowClass} */}
                                       <td>
                                        {driver.isCustom ? (
                                            <input
                                                type="text"
                                                value={driver.customCostDriver || ''}
                                                onChange={(e) => {
                                                    const updatedDrivers = [...blastingCostDriversActuals];
                                                    updatedDrivers[index].customCostDriver = e.target.value;
                                                    updatedDrivers[index].costDriver = e.target.value;
                                                    setBlastingCostDriversActuals(updatedDrivers);
                                                }}
                                                placeholder="Type the Cost Driver"
                                                className={`form-control ${submitAttempted && !driver.costDriver ? 'required-field' : ''}`}
                                                style={{ width: '100%' }}  // Ensure full width
                                            />
                                        ) : (
                                            <div className={submitAttempted && !driver.costDriver ? 'react-select-required' : ''} style={{ width: '100%' }}>
                                                {driver.isNew && (
                                                    <span className="over-expenditure-text">
                                                        Additional Cost Driver 
                                                    </span>
                                                )}
                                                <Select
                                                    options={[
                                                        ...costDriverOptions.map((opt) => ({
                                                            value: opt.costDriver,
                                                            label: opt.costDriver,
                                                        })),
                                                        { value: 'Other', label: 'Other' }
                                                    ]}
                                                    value={
                                                        driver.costDriver
                                                            ? { value: driver.costDriver, label: driver.costDriver }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) => {
                                                        const updatedDrivers = [...blastingCostDriversActuals];
                                                        
                                                        if (!selectedOption) {
                                                            Object.assign(updatedDrivers[index], {
                                                                costDriver: "",
                                                                isCustom: false,
                                                                customCostDriver: "",
                                                                supportDocuments: "",
                                                                unitPrice: ""
                                                            });
                                                        } else if (selectedOption.value === "Other") {
                                                            Object.assign(updatedDrivers[index], {
                                                                costDriver: "",
                                                                isCustom: true,
                                                                customCostDriver: "",
                                                                supportDocuments: "",
                                                                unitPrice: ""
                                                            });
                                                        } else {
                                                            Object.assign(updatedDrivers[index], {
                                                                costDriver: selectedOption.value,
                                                                isCustom: false,
                                                                customCostDriver: "",
                                                                supportDocuments: "",
                                                                unitPrice: ""
                                                            });
                                                        }
                                                        setBlastingCostDriversActuals(updatedDrivers);
                                                    }}
                                                    isClearable
                                                    placeholder="Select Blasting Cost Driver"
                                                    className="custom-select-control"
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            borderColor: submitAttempted && !driver.costDriver ? '#dc3545' : provided.borderColor,
                                                            minHeight: '38px',
                                                            height: '38px',
                                                            width: '100%',
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 999,
                                                        }),
                                                    }}
                                                />
                                            </div>
  

                                        )}
                                        {/* ✅ ADD THE JUSTIFICATION INPUT HERE - AFTER the Select wrapper closes */}
                                        {driver.isNew && (
                                            <input
                                                type="text"
                                                placeholder="Type your justification here"
                                                className="form-control justification-input"
                                                value={driver.justification || ""}
                                                onChange={(e) => {
                                                    const updatedDrivers = [...blastingCostDriversActuals];
                                                    updatedDrivers[index].justification = e.target.value;
                                                    setBlastingCostDriversActuals(updatedDrivers);
                                                }}
                                            />
                                        )}
                                    </td>


                                       <td>
                                        <input
                                            type="text"
                                            className={`form-control ${submitAttempted && (driver.quantity === '' || driver.quantity === null || driver.quantity === undefined) ? 'required-field' : ''}`}
                                            inputMode="decimal"
                                            value={driver.quantity !== undefined && driver.quantity !== '' ? Number(driver.quantity).toLocaleString('en-US') : ''}
                                            onChange={e => {
                                                const raw = e.target.value.replace(/[^0-9.]/g, '');
                                                handleBlastingActualInputChange(index, 'quantity', raw);
                                            }}
                                            onBlur={e => {
                                                const raw = e.target.value.replace(/[^0-9.]/g, '');
                                                const num = Number(raw) || 0;
                                                handleBlastingActualInputChange(index, 'quantity', num.toString());
                                            }}
                                        />
                                    </td>

                                        <td>
                                          <input
                                              type="text"
                                              className={`form-control ${submitAttempted && (driver.unitPrice === '' || driver.unitPrice === null || driver.unitPrice === undefined) ? 'required-field' : ''}`}
                                              inputMode="decimal"
                                              value={driver.unitPrice !== undefined && driver.unitPrice !== '' ? formatCurrency(Number(driver.unitPrice)) : ''}
                                              onChange={e => {
                                                  const raw = e.target.value.replace(/[^0-9.]/g, '');
                                                  handleBlastingActualInputChange(index, 'unitPrice', raw);
                                              }}
                                              onBlur={e => {
                                                  const raw = e.target.value.replace(/[^0-9.]/g, '');
                                                  const num = Number(raw) || 0;
                                                  handleBlastingActualInputChange(index, 'unitPrice', num.toString());
                                              }}
                                          />
                                        </td>

                                       <td>
                                          <input
                                              type="text"
                                              className={`form-control ${submitAttempted && (driver.actualSpent === '' || driver.actualSpent === null || driver.actualSpent === undefined) ? 'required-field' : ''}`}
                                              inputMode="decimal"
                                              value={driver.actualSpent !== undefined && driver.actualSpent !== '' ? formatCurrency(Number(driver.actualSpent)) : ''}
                                             
                                              onChange={e => {
                                                  const raw = e.target.value.replace(/[^0-9.]/g, '')
                                                  handleBlastingActualInputChange(index, 'actualSpent', raw)  
                                              }}
                                              onBlur={e => {
                                                  const raw = e.target.value.replace(/[^0-9.]/g, '')
                                                  const num = Number(raw) || 0
                                                  handleBlastingActualInputChange(index, 'actualSpent', num.toString())
                                              }}
                                          />
                                      </td>

                                      <td>
                                          {Number(driver.actualSpent) === 0 && driver.actualSpent !== '' && driver.actualSpent !== null && driver.actualSpent !== undefined ? (
                                              <div className="na-message" style={{ textAlign: 'center', padding: '8px 0' }}>
                                                  <span style={{ fontWeight: '499' }}>N/A</span>
                                                  <div style={{ fontSize: '17px', color: '#868e96' }}>(No support document is required)</div>
                                              </div>
                                          ) : (
                                              // Show the attachment section by default (when actualSpent is empty or > 0)
                                              <div className={`attachment-section ${submitAttempted && !driver.attachmentType ? 'attachment-validation-error' : ''}`}>
                                                  <label>
                                                      <input
                                                          type="checkbox"
                                                          checked={driver.attachmentType === "physical"}
                                                          onChange={() => handleBlastingAttachmentTypeChange(index, "physical")}
                                                          className="the-checkbox-input"
                                                      />
                                                      Physical attachments
                                                  </label>

                                                  <label>
                                                      <input
                                                          type="checkbox"
                                                          checked={driver.attachmentType === "digital"}
                                                          onChange={() => handleBlastingAttachmentTypeChange(index, "digital")}
                                                          className="the-checkbox-input"
                                                      />
                                                      Digital attachments
                                                  </label>
                                                  
                                                  {submitAttempted && !driver.attachmentType && (
                                                      <div className="validation-message" style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                                                          Please select either Physical or Digital attachments
                                                      </div>
                                                  )}
                                                  <br/>

                                                  {driver.attachmentType === "digital" && (
                                                      <div className="custom-file-input-container">
                                                          <label className="custom-file-input-label">
                                                              <input
                                                                  type="file"
                                                                  id={`blasting-support-documents-${index}`}
                                                                  name={`blastingFiles[${index}]`}
                                                                  className="hidden-file-input"
                                                                  accept="application/pdf"
                                                                  multiple
                                                                  onChange={(e) => handleBlastingFileChange(index, e)}
                                                              />
                                                              <span className="custom-file-text">Choose Files</span>
                                                              <span className="plus-symbol">+</span>
                                                          </label>
                                                          
                                                          {submitAttempted && driver.attachmentType === "digital" && (!driver.selectedFiles || driver.selectedFiles.length === 0) && (
                                                              <div className="validation-message" style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                                                                  Please upload at least one PDF file
                                                              </div>
                                                          )}
                                                      </div>
                                                  )}

                                                  {driver.selectedFiles && driver.selectedFiles.length > 0 && (
                                                      <div className="selected-files">
                                                          <b>Selected Files:</b>
                                                          <ul>
                                                              {driver.selectedFiles.map((file, fileIndex) => (
                                                                  <li key={fileIndex}>{file.name}</li>
                                                              ))}
                                                          </ul>
                                                      </div>
                                                  )}
                                              </div>
                                          )}
                                      </td>


                                       <td>
                                        {blastingCostDriversActuals.length >= 1 && ( 
                                            <button
                                                type="button"
                                                className="btn btn-danger delete"
                                                onClick={() => {
                                                    const updatedDrivers = blastingCostDriversActuals.filter((_, i) => i !== index);
                                                    setBlastingCostDriversActuals(updatedDrivers);
                                                }}
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                        )}
                                    </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'right' }}>
                                    <b>Total:</b>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control read-only black-text"
                                        inputMode="decimal"
                                        value={formatCurrency(
                                            blastingCostDriversActuals.reduce(
                                                (acc, driver) => acc + (Number(driver.actualSpent) || 0),
                                                0
                                            )
                                        )}
                                        readOnly
                                    />
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                ) : (
                    <p>No blasting cost drivers</p>
                )}

                {/* Add Row Button */}
                <button type="button" className="round-button" onClick={() => {
                    const newDriver = {
                        id: null,
                        costDriver: '',
                        customCostDriver: '',
                        isCustom: false,
                        justification: '',
                        quantity: '',
                        unitPrice: '',
                        actualSpent: '',
                        selectedFiles: [],
                        attachmentType: '',
                        isNew: true
                    };
                    setBlastingCostDriversActuals([...blastingCostDriversActuals, newDriver]);
                }}>
                    <i className="fas fa-plus"></i>
                </button>
            </div>
     <div className="details-group">
                    

                {/* Blasting Advance, Actuals & Variances Table */}
                <div id="cost-drivers-wrapper">
                    <h3>Blasting Approved Amounts, Actuals & Variances</h3>
                    {blastingCostDriversActuals && blastingCostDriversActuals.length > 0 ? (
                        <table className="table-bordered">
                            <thead>
                                <tr>
                                    <th>Cost Driver</th>
                                    <th>Advance</th>
                                    <th>Actual Spent</th>
                                    <th>Variances</th>
                                    <th style={{ minWidth: '220px' }}>Reason for Variance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {blastingCostDriversActuals.map((driver, index) => {
                                    const advance = Number(blastingCostItems[index]?.total || 0);
                                    const actualSpent = Number(driver.actualSpent || 0);
                                    const variance = advance - actualSpent;
                                    const hasVariance = Math.abs(variance) > 0.005;
                                    const rowClass = driver.isNew ? "new-row" : "";  
                                    
                                    return (
                                        <tr key={`blasting-advance-${index}`} className={rowClass}>  
                                            <td>
                                                <input
                                                    type="text"
                                                    value={driver.costDriver || ''}
                                                    readOnly
                                                    className="form-control read-only"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control read-only black-text"
                                                    inputMode="decimal"
                                                    value={formatCurrencyForSecondTable(advance)}
                                                    readOnly
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control read-only black-text"
                                                    inputMode="decimal"
                                                    value={formatCurrencyForSecondTable(actualSpent)}
                                                    readOnly
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control read-only black-text"
                                                    inputMode="decimal"
                                                    value={formatCurrencyForSecondTable(variance)}
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ minWidth: '180px' }}>
                                              <input
                                                  type="text"
                                                  className={`form-control ${hasVariance ? 'editable-variance-reason' : 'read-only'}`}
                                                  placeholder={hasVariance ? "Type the reason for variance" : "N/A (No variance)"}
                                                  value={driver.reasonForVariance || ""}
                                                  onChange={(e) => {
                                                      const updatedDrivers = [...blastingCostDriversActuals];
                                                      updatedDrivers[index].reasonForVariance = e.target.value;
                                                      setBlastingCostDriversActuals(updatedDrivers);
                                                  }}
                                                  readOnly={!hasVariance}
                                                  disabled={!hasVariance}
                                                  style={{ width: '230px' }} 
                                              />
                                          </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td style={{ textAlign: 'right' }}>
                                        <b>Totals:</b>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control read-only black-text"
                                            inputMode="decimal"
                                            value={formatCurrencyForSecondTable(
                                                blastingCostItems.reduce((acc, item) => acc + (Number(item.total) || 0), 0)
                                            )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control read-only black-text"
                                            inputMode="decimal"
                                            value={formatCurrencyForSecondTable(
                                                blastingCostDriversActuals.reduce(
                                                    (acc, driver) => acc + (Number(driver.actualSpent) || 0),
                                                    0
                                                )
                                            )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control read-only black-text"
                                            inputMode="decimal"
                                            value={formatCurrencyForSecondTable(
                                                blastingCostItems.reduce((acc, item) => acc + (Number(item.total) || 0), 0) -
                                                blastingCostDriversActuals.reduce((acc, driver) => acc + (Number(driver.actualSpent) || 0), 0)
                                            )}
                                            readOnly
                                        />
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    ) : (
                        <p>No blasting cost drivers</p>
                    )}


                    <div id="cost-drivers-wrapper">
                      <h3>Other Cost Drivers – Actuals</h3>
                      {costDriversData.length > 0 ? (
                        <table className="table-bordered">
                        <thead>
                          <tr>
                            <th>Cost Driver</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Actual Spent</th>
                            <th>Support Documents (PDF)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {costDriversData.map((driver, index) => {
                            const rowKey = `cost-drivers-${index}`;
                            const rowClass = driver.isNew ? "new-row" : "";
                  
                            return (
                              <tr key={rowKey} className={rowClass}>
                                <td>
                                  {driver.isCustom ? (
                                    <input
                                      type="text"
                                      value={driver.costDriver}
                                      onChange={(e) => handleCustomInputChange(index, e.target.value)}
                                      className={`form-control ${submitAttempted && !driver.costDriver ? 'required-field' : ''}`}
                                      placeholder="Type the Cost Driver"
                                    />
                                  ) : (
                                    <div className={`dropdown-wrapper ${submitAttempted && !driver.costDriver ? 'react-select-required' : ''}`}>
                                      {driver.isNew && (
                                        <span className="over-expenditure-text">
                                          Additional Cost Driver 
                                        </span>
                                      )}
                                      <select
                                        value={driver.costDriver}
                                        onChange={(e) => handleInputChange(index, 'costDriver', e.target.value)}
                                        className={`form-control cost-driver-dropdown ${submitAttempted && !driver.costDriver ? 'required-field' : ''}`}
                                      >
                                        <option value="">Select Cost Driver</option>
                                        <option value="FCI Staff Perdiem">FCI Staff Perdiem</option>
                                        <option value="Partners DSA">Partners DSA</option>
                                        <option value="Government Staff DSA -AEDC, AEDO LVCDO">
                                          Government Staff DSA -AEDC, AEDO LVCDO
                                        </option>
                                        <option value="Field Staff DSA">Field Staff DSA</option>
                                        <option value="Venue/Hall Hire">Venue/Hall Hire</option>
                                        <option value="Snacks">Snacks</option>
                                        <option value="Refreshments">Refreshments</option>
                                        <option value="Lunch Allowance">Lunch Allowance</option>
                                        <option value="Transport Refund">Transport Refund</option>
                                        <option value="Stationery">Stationery</option>
                                        <option value="Scanning, printing & photocopy">
                                          Scanning, printing & photocopy
                                        </option>
                                        <option value="Training Materials">Training Materials</option>
                                        <option value="PA System hire">PA System hire</option>
                                        <option value="Genset Hire">Genset Hire</option>
                                        <option value="Vehicle Hire">Vehicle Hire</option>
                                        <option value="Vehicle Fuel">Vehicle Fuel</option>
                                        <option value="Toll Gate Fee">Toll Gate Fee</option>
                                        <option value="Other">Other</option>
                                      </select>
                                      <i className="fas fa-chevron-down dropdown-icon"></i>
                                    </div>
                                  )}
                                  {driver.isNew && (
                                    <input
                                      type="text"
                                      placeholder="Type your justification here"
                                      className="form-control justification-input"
                                      value={driver.justification || ""}
                                      onChange={(e) => handleJustificationChange(index, e.target.value)}
                                    />
                                  )}
                                </td>
                               <td>
                                <input
                                    value={driver.quantity !== undefined && driver.quantity !== '' ? Number(driver.quantity).toLocaleString('en-US') : ''}
                                    onChange={(e) => {
                                        const raw = e.target.value.replace(/[^0-9.]/g, '');
                                        handleInputChange(index, "quantity", raw);
                                    }}
                                    onBlur={e => {
                                        const raw = e.target.value.replace(/[^0-9.]/g, '');
                                        const num = Number(raw) || 0;
                                        handleInputChange(index, "quantity", num.toString());
                                    }}
                                    className={`form-control ${submitAttempted && (driver.quantity === '' || driver.quantity === null || driver.quantity === undefined) ? 'required-field' : ''}`}
                                    placeholder=""
                                />
                            </td>

                             <td>
                                <input
                                    type="text"
                                    className={`form-control ${submitAttempted && (driver.unitPrice === '' || driver.unitPrice === null || driver.unitPrice === undefined) ? 'required-field' : ''}`}
                                    inputMode="decimal"
                                    value={driver.unitPrice !== undefined && driver.unitPrice !== '' ? formatCurrency(Number(driver.unitPrice)) : ''}
                                    onChange={e => {
                                        const raw = e.target.value.replace(/[^0-9.]/g, '')
                                        handleInputChange(index, 'unitPrice', raw)
                                    }}
                                    onBlur={e => {
                                        const raw = e.target.value.replace(/[^0-9.]/g, '')
                                        const num = Number(raw) || 0
                                        handleInputChange(index, 'unitPrice', num.toString())
                                    }}
                                />
                            </td>                                
                            <td>
                                <input
                                  type="text"
                                  className={`form-control ${submitAttempted && (driver.actualSpent === '' || driver.actualSpent === null || driver.actualSpent === undefined) ? 'required-field' : ''}`}
                                  inputMode="decimal"
                                  value={driver.actualSpent !== undefined && driver.actualSpent !== '' ? formatCurrency(Number(driver.actualSpent)) : ''}  // ✅ Only show 0 if user entered it
                                  onChange={e => {
                                    const raw = e.target.value.replace(/[^0-9.]/g, '')
                                    handleInputChange(index, 'actualSpent', raw)
                                  }}
                                  onBlur={e => {
                                    const raw = e.target.value.replace(/[^0-9.]/g, '')
                                    const num = Number(raw) || 0
                                    handleInputChange(index, 'actualSpent', num.toString())
                                  }}
                                />
                              </td>
                              <td>
                                  {Number(driver.actualSpent) === 0 && driver.actualSpent !== '' && driver.actualSpent !== null && driver.actualSpent !== undefined ? (
                                      // Show "N/A" when actualSpent is explicitly 0
                                      <div className="na-message" style={{ textAlign: 'center', padding: '8px 0' }}>
                                         <span style={{ fontWeight: '499' }}>N/A</span>
                                         <div style={{ fontSize: '17px', color: '#868e96' }}>(No support document is required)</div>
                                       </div>                                  ) : (
                                      // Show the attachment section by default (when actualSpent is empty or > 0)
                                      <div className={`attachment-section ${submitAttempted && !driver.attachmentType ? 'attachment-validation-error' : ''}`}>
                                          <label>
                                              <input
                                                  type="checkbox"
                                                  checked={driver.attachmentType === "physical"}
                                                  onChange={() => handleSupportDocumentsCheckboxChange("physical", index)}
                                                  className="the-checkbox-input"
                                              />
                                              Physical attachments
                                          </label>

                                          <label>
                                              <input
                                                  type="checkbox"
                                                  checked={driver.attachmentType === "digital"}
                                                  onChange={() => handleSupportDocumentsCheckboxChange("digital", index)}
                                                  className="the-checkbox-input"
                                              />
                                              Digital attachments
                                          </label>
                                          
                                          {/* Validation message for attachment type */}
                                          {submitAttempted && !driver.attachmentType && (
                                              <div className="validation-message" style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                                                  Please select either Physical or Digital attachments
                                              </div>
                                          )}
                                          <br/>

                                          {driver.attachmentType === "digital" && (
                                              <div className="custom-file-input-container">
                                                  <label className="custom-file-input-label">
                                                      <input
                                                          type="file"
                                                          id={`support-documents-${index}`}
                                                          name={`files[${index}]`}              
                                                          className="hidden-file-input"
                                                          accept="application/pdf"
                                                          multiple
                                                          onChange={(e) => handleFileChange(index, e)}
                                                      />
                                                      <span className="custom-file-text">Choose Files</span>
                                                      <span className="plus-symbol">+</span>
                                                  </label>
                                                  
                                                  {/* Validation for digital files */}
                                                  {submitAttempted && driver.attachmentType === "digital" && (!driver.selectedFiles || driver.selectedFiles.length === 0) && (
                                                      <div className="validation-message" style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                                                          Please upload at least one PDF file
                                                      </div>
                                                  )}
                                              </div>
                                          )}

                                          {driver.selectedFiles.length > 0 && (
                                              <div className="selected-files">
                                                  <b>Selected Files:</b>
                                                  <ul>
                                                      {driver.selectedFiles.map((file, fileIndex) => (
                                                          <li key={fileIndex}>{file.name}</li>
                                                      ))}
                                                  </ul>
                                              </div>
                                          )}

                                          {showPopup && (
                                              <div className="popup-overlay">
                                                  <div className="popup">
                                                      <h4>Not a PDF</h4>
                                                      <p>The file you have selected is not a PDF document. Please select a PDF document.</p>
                                                      <button onClick={closePopup} className="btn btn-primary">
                                                          OK
                                                      </button>
                                                  </div>
                                              </div>
                                          )}
                                      </div>
                                  )}
                              </td>

                                      

                                       {/* Additional Cost Driver text - only shows for new rows */}
                                        

                                        {/* Delete button - shows for ALL rows */}
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-danger delete"
                                                onClick={() => removeRow(index)}
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </td>
                                      </tr>
                    );
                

                  
                    })}
                  </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="3" style={{ textAlign: "right" }}>
                              <b>Total:</b>
                            </td>
                            <td>
                              <input
                                    type="text"
                                    className="form-control read-only black-text"
                                    inputMode="decimal"
                                    value={formatCurrency(
                                      costDriversData.reduce(
                                        (acc, driver) => acc + (Number(driver.actualSpent) || 0),
                                        0
                                      )
                                    )}
                                    readOnly
                                  />
                            </td>
                           
                            <td colSpan="2"></td>
                          </tr>
                        </tfoot>
                      </table>
                      ) : (
                        <p>No other cost drivers</p>
                      )}

                      <button type="button" className="round-button" onClick={addRow}>
                        <i className="fas fa-plus"></i>  
                      </button>
                    </div>

                    {/* Add Row Button */}



                </div>





                    <div className="details-group">
                      <div id="cost-drivers-wrapper">
                        <h3>Other Cost Drivers - Advance, Actuals & Variances</h3>
                        {costDriversData.length > 0 ? (
                            <table className="table-bordered">
                                <thead>
                                    <tr>
                                        <th>Cost Driver</th>
                                        <th>Advance</th>
                                        <th>Actual Spent</th>
                                        <th>Variances</th>
                                        <th style={{ minWidth: '220px' }}>Reason for Variance</th>
                                    </tr>
                                </thead>
                               <tbody>
                                {costDriversData.map((cDriver, index) => {
                                    const advance = Number(
                                        requisition.costDrivers[index]?.total || 0
                                    );
                                    const actualSpent = Number(cDriver.actualSpent || 0);
                                    const variance = advance - actualSpent;
                                    const hasVariance = Math.abs(variance) > 0.005;
                                    const rowClass = cDriver.isNew ? "new-row" : "";  
                                    
                                    return (
                                        <tr key={`test-${index}`} className={rowClass}>  
                                            <td>
                                                <input
                                                    type="text"
                                                    value={cDriver.costDriver || ''}
                                                    readOnly
                                                    className="form-control read-only"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control read-only black-text"
                                                    inputMode="decimal"
                                                    value={formatCurrencyForSecondTable(advance)}
                                                    readOnly
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control read-only black-text"
                                                    inputMode="decimal"
                                                    value={formatCurrencyForSecondTable(actualSpent)}
                                                    readOnly
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control read-only black-text"
                                                    inputMode="decimal"
                                                    value={formatCurrencyForSecondTable(variance)}
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ minWidth: '180px' }}>
                                              <input
                                                  type="text"
                                                  className={`form-control ${hasVariance ? 'editable-variance-reason' : 'read-only'}`}
                                                  placeholder={hasVariance ? "Type the reason for variance" : "N/A (No variance)"}
                                                  value={cDriver.reasonForVariance || ""}
                                                  onChange={(e) => {
                                                      const updatedDrivers = [...costDriversData];
                                                      updatedDrivers[index].reasonForVariance = e.target.value;
                                                      setCostDriversData(updatedDrivers);
                                                  }}
                                                  readOnly={!hasVariance}
                                                  disabled={!hasVariance}
                                                  style={{ width: '230px' }} 
                                              />
                                          </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                                <tfoot>
                                    <tr>
                                        <td style={{ textAlign: 'right' }}>
                                            <b>Totals:</b>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control read-only black-text"
                                                inputMode="decimal"
                                                value={formatCurrencyForSecondTable(
                                                    requisition.costDrivers.reduce(
                                                        (acc, driver) => acc + (Number(driver.total) || 0),
                                                        0
                                                    )
                                                )}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control read-only black-text"
                                                inputMode="decimal"
                                                value={formatCurrencyForSecondTable(
                                                    costDriversData.reduce(
                                                        (acc, driver) => acc + Number(driver.actualSpent || 0),
                                                        0
                                                    )
                                                )}
                                                readOnly
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control read-only black-text"
                                                inputMode="decimal"
                                                value={formatCurrencyForSecondTable(
                                                    requisition.costDrivers.reduce(
                                                        (acc, driver) => acc + (Number(driver.total) || 0),
                                                        0
                                                    ) -
                                                    costDriversData.reduce(
                                                        (acc, driver) => acc + Number(driver.actualSpent || 0),
                                                        0
                                                    )
                                                )}
                                                readOnly
                                            />
                                        </td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        ) : (
                          <p>No other cost drivers</p>
                        )}

                        <button type="button" className="round-button" onClick={addRow}>
                          <i className="fas fa-plus"></i>  
                        </button>

                        
                      <div className="variance-summary" style={{ marginTop: '20px' }}>
                          <div id="cost-drivers-wrapper">
                              <h3>Summary</h3>
                              <table className="table-bordered" style={{ width: '100%', marginTop: '10px' }}>
                                  <thead>
                                      <tr>
                                          <th style={{ textAlign: 'left', padding: '8px' }}>Category</th>
                                          <th style={{ textAlign: 'right', padding: '8px' }}>Variance Total</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr>
                                          <td style={{ padding: '8px' }}>Blasting Variance Total</td>
                                          <td style={{ textAlign: 'right', padding: '8px' }}>
                                              <input
                                                  type="text"
                                                  className="form-control read-only black-text"
                                                  style={{ display: 'inline-block', width: 'auto', minWidth: '150px', textAlign: 'right' }}
                                                  value={formatCurrencyForSecondTable(blastingTotalVariance)}
                                                  readOnly
                                              />
                                          </td>
                                      </tr>
                                      <tr>
                                          <td style={{ padding: '8px' }}>Other Cost Driver Variance Total</td>
                                          <td style={{ textAlign: 'right', padding: '8px' }}>
                                              <input
                                                  type="text"
                                                  className="form-control read-only black-text"
                                                  style={{ display: 'inline-block', width: 'auto', minWidth: '150px', textAlign: 'right' }}
                                                  value={formatCurrencyForSecondTable(otherTotalVariance)}
                                                  readOnly
                                              />
                                          </td>
                                      </tr>
                                      <tr style={{ fontWeight: 'bold' }}>
                                          <td style={{ padding: '8px' }}>Overall Total</td>
                                          <td style={{ textAlign: 'right', padding: '8px' }}>
                                              <input
                                                  type="text"
                                                  className="form-control read-only black-text"
                                                  style={{ display: 'inline-block', width: 'auto', minWidth: '150px', textAlign: 'right', fontWeight: 'bold' }}
                                                  value={formatCurrencyForSecondTable(overallTotalVariance)}
                                                  readOnly
                                              />
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <br/><br/><br/>
                          </div>

                      </div>

                      {/* Hidden "According to the above..." div - kept for reference but hidden */}
                      <div className="variance-summary" style={{ display: 'none' }}>
                          {totalVariance > 0 && (
                              <p>
                                  <i>According to the above,</i> <br/>
                                  You have <strong>{formatCurrencyForSecondTable(totalVariance)}</strong> remaining. <br/><br/>
                                  After you submit your surrender form, the Finance and Administration department will cross-check and confirm. <br/>
                              </p>
                          )}
                          {totalVariance < 0 && (
                              <p>
                                  <i>According to the above,</i> <br/>
                                  You have overspent by <strong>{formatCurrencyForSecondTable(Math.abs(totalVariance))}</strong>. <br/><br/>
                                  After you submit your surrender form, the Finance and Administration department will cross-check and confirm. <br/>
                              </p>
                          )}
                          {totalVariance === 0 && (
                              <p>
                                  <i>According to the above,</i> <br/>
                                  You have spent all the money that you were advanced, which implies that you don't owe any money to the office and the office doesn't owe any money to you. <br/><br/>
                                  After you submit your surrender form, the Finance and Administration department will cross-check and confirm. <br/>
                              </p>
                          )}
                      </div>

                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                <div className="checkbox-container">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={isConfirmed}
                      onChange={handleCheckboxChange}
                      className="checkbox"
                    />
                    I confirm that the information above is accurate.
                  </label>
                </div>

                {isConfirmed && (
                  <div className="signature-container">
                    <div className="signed-by-label">Signed by:</div>
                    <img
                      src={`${process.env.REACT_APP_STATIC_BASE_URL}/${signatureFilePath}`}
                      alt="User Signature"
                      className="signature-image"
                    />
                    <div className="user-full-name">{fullName}</div>
                    <br/>

                    {
                      /*
                      
                      <button
                      type="submit"
                      id="surrender-submit-button"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                      
                      
                      
                      */
                    }
                    
                    <button type="submit" id="surrender-submit-button" className="btn btn-primary">Submit</button>

                  </div>
                )}
              </form>

              <PopupModal
                title="Submitted"
                titleStyle="success-title"
                message="Your surrender has been submitted successfully."
                icon={faCheckCircle}
                isVisible={showSurrenderSubmittedModal}
                onClose={() => {
                  handleSurrenderSubmittedModalClose();
                }}
                iconBorder="popup-modal-icon"
              />
              <PopupModal
                title={errorModal.title || "Error"} 
                titleStyle="error-title"
                message={errorModal.message || "An error has occurred"}
                icon={faTimesCircle}
                isVisible={errorModal.show}  // Important: pass just the show property
                onClose={() => {
                  setErrorModal(prev => ({ ...prev, show: false }));
                }}
                iconBorder="popup-modal-icon"
              />
              <PopupModal
                title="No internet connection"
                titleStyle="error-title"
                message="Please connect to the internet and try again."
                icon={faWifi}
                isVisible={showNoInternetModal}
                onClose={() => {
                  setShowNoInternetModal(false);
                }}
                iconBorder="popup-modal-icon"
              />
            </div>
          </div>
        </div>

        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
          </div>
        </footer>
      </div>

      {duplicateFilePopup.show && (
        <div className="popup-overlay">
          <div className="popup">
            <h4>File Not Uploaded</h4>
            <p>
              The file name of this PDF file that you are trying to upload is the same
              as one of the PDF files you already uploaded. Are you trying to re-upload the
              same file?
            </p>
            <button onClick={closeDuplicateFilePopup} className="btn btn-primary">
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurrenderForm;